import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryOptions } from '@cast/shared-types';
import { DboInstancesTelemetryResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getInstanceTelemetry;

const DBO_INSTANCES_TELEMETRY_QUERY_KEY = 'dbo-instances-telemetry';

const getInstancesTelemetryQueryKey = (organizationId?: string) => {
  return [DBO_INSTANCES_TELEMETRY_QUERY_KEY, organizationId] as const;
};

type InstancesTelemetryData = DboInstancesTelemetryResponse | undefined;

export const useInstancesTelemetryQuery = <TSelected = InstancesTelemetryData>(
  params: { organizationId?: string },
  options?: QueryOptions<InstancesTelemetryData, TSelected>
) =>
  useQuery(
    queryOptions({
      queryKey: getInstancesTelemetryQueryKey(params.organizationId),
      queryFn: async (): Promise<InstancesTelemetryData> => {
        try {
          const { data } = await apiFn({
            organizationId: params.organizationId ?? '',
          });
          return data;
        } catch {
          return undefined;
        }
      },
      enabled: !!params.organizationId && (options?.enabled ?? true),
      ...options,
    })
  );
